export default "__VITE_PUBLIC_ASSET__128ecb7f__"